export function createClientMessageId() {
    if (typeof window !== 'undefined' && window.crypto?.randomUUID) return window.crypto.randomUUID()
    return `local-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export function reconcileServerMessages(currentMessages = [], serverMessages = []) {
    const pending = currentMessages.filter((item) => !item.serverId)
    const matchedPending = new Set()
    const normalized = serverMessages.map((item) => {
        const content = item.content || item.message
        const match = pending.find((candidate) =>
            !matchedPending.has(candidate.clientId)
            && candidate.role === item.role
            && candidate.message === content,
        )
        if (match) matchedPending.add(match.clientId)
        return {
            role: item.role,
            message: content,
            serverId: item.id || null,
            clientId: match?.clientId || null,
            status: item.payload?.queue?.status || 'sent',
            createdAt: item.created_at || match?.createdAt || null,
            payload: item.payload || null,
            attachments: Array.isArray(item.attachments) ? item.attachments : (match?.attachments || []),
        }
    })
    const stillPending = pending.filter((item) => !matchedPending.has(item.clientId))
    return [...normalized, ...stillPending]
}

export function confirmOptimisticMessage(messages, clientId, serverId, status = null) {
    const optimistic = messages.find((item) => item.clientId === clientId)
    if (!optimistic) return false
    optimistic.serverId = serverId
    if (status) optimistic.status = status
    return true
}

export function assistantQueueStatus(item) {
    return item?.payload?.queue?.status || item?.status || 'sent'
}

export function splitAssistantMessages(messages = []) {
    const queued = []
    const transcript = []
    messages.forEach((item) => {
        if (item?.role === 'user' && assistantQueueStatus(item) === 'queued') {
            queued.push(item)
        } else {
            transcript.push(item)
        }
    })
    return { queued, transcript }
}

export function assistantMessageSources(item) {
    return item?.role === 'assistant' && Array.isArray(item?.payload?.manager?.citations)
        ? item.payload.manager.citations
        : []
}
